module.exports = __webpack_public_path__ + "static/img/hubeimylogo.1f66449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/hubeimylogo.png
// module id = vwB/
// module chunks = 44